export const environment = {
  production: false,
  url:'https://dev-posm.vthgdigital.com/api'
};
